import { LinearTransform } from '@st/geom'
import { BoxConstraints, PaintOp, RenderBox } from '../rendering'
import { renderElement } from '../document'

type PathProps = {
  d: string
  fill?: string
  stroke?: string
  strokeWidth?: number
  transform?: LinearTransform
}

export class PathRenderBox extends RenderBox<PathProps> {
  performLayout(constraints: BoxConstraints) {
    // Occupy the full constraint box (tight constraints expected from parent)
    this.box = {
      x: 0,
      y: 0,
      width: constraints.maxWidth,
      height: constraints.maxHeight
    }
  }

  draw(): PaintOp {
    return {
      type: 'path',
      bounds: this.box,
      path: this.props.d,
      fill: this.props.fill,
      stroke: this.props.stroke,
      stroke_width: this.props.strokeWidth,
      transform: this.props.transform
    }
  }
}

export function Path({ d, fill, stroke, strokeWidth, transform }: PathProps) {
  return renderElement(new PathRenderBox({ d, fill, stroke, strokeWidth, transform }))
}
